export enum Consents {
  Necessary = 'necessary',
  All = 'all',
}
